import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../router/privateRoute';

// Views
import Home from '../views/home';
import Movements from '../views/stocks/movements/MovementsView';
import Orders from '../views/orders';
import OrderDetail from '../views/orders/detail';
import OrderFailed from '../views/orders/failed';
import UpdateOrder from '../views/orders/update';
import InventoryView from '../views/stocks/Inventory/InventoryView';

import Archings from '../views/Archings';
import CashRegisterMovements from '../views/cashRegisters/movements';
import Closures from '../views/closures';
import CreateClosureModal from '../views/closures/create';
import ClosureDetail from '../views/closures/detail';
import CreateArching from '../views/Archings/create';
import ArchingDetail from '../views/Archings/detail';
import Customer from '../views/Customers/index';
import CustomerCreate from '../views/Customers/create/index';
import InternalVouchers from '../views/internalVouchers/index';
import CreateInternalVouchers from '../views/internalVouchers/create/index';
import DetailInternalVouchers from '../views/internalVouchers/detail/index';
import CashRegisterViewTotal from '../views/cashRegisters/viewTotal/index';
import CashRegisterImprestMovements from '../views/cashRegisters/imprestMovements/index';
import StockControlEdition from '../views/stockControls/create';
import Catalogs from '../views/catalogs'

import MovementReception from '../views/movements/reception';
import MovementEditionView from '../views/movements/ingress';
import MovementTransfer from '../views/movements/egress';

import StockControls from '../views/stockControls';
import StockControlView from '../views/stockControls/details';
import { types, subTypes } from '../models/MovementEntity';
import Unauthorized from '../views/unauthorized';
import { Permissions } from '../models/Roles';
import ReplacementUnits from '../views/replacementUnits/index'
import Invoices from '../views/invoices'
import Invoice from '../views/invoices/detail';
import Vouchers from '../views/vouchers';
import Voucher from '../views/vouchers/detail';
import MovementStockView from '../views/movements/detail/index';

import ReferralsView from '../views/stocks/referrals/ReferralsView';
import ReferralDetailView from '../views/stocks/referrals/ReferralDetailView';
import ProductHistory from '../views/stocks/product-history/ProductHistoryView';
import Settlements from '../views/lotClosures';

const Router = () => {
    return (
        <Routes>
            <Route path='' element={<Home />} />
            <Route path='/unauthorized/:message' element={<Unauthorized />} />

            <Route
                path="/orders"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <Orders />
                    </PrivateRoute>}
            />

            {/* Migración de las rutas protegidas */}
            <Route
                path="/orders/search"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <Orders />
                    </PrivateRoute>
                }
            />
            <Route
                path="/orders/detail/:orderId"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <OrderDetail />
                    </PrivateRoute>
                }
            />
            <Route
                path="/orders/:orderId/failed"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <OrderFailed />
                    </PrivateRoute>
                }
            />
            <Route
                path="/orders/:orderId"
                element={
                    <PrivateRoute permission={[Permissions.SalesEdit]}>
                        <UpdateOrder />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stockControls"
                element={
                    <PrivateRoute permission={[Permissions.StockControl]}>
                        <StockControls />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stockControls/create"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <StockControlEdition />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stockControls/:stockControlId"
                element={
                    <PrivateRoute permission={[Permissions.StockControl]}>
                        <StockControlView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stockControls/update/:stockControlId"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <StockControlEdition />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stocks/inventory"
                element={
                    <PrivateRoute permission={[Permissions.StockView]}>
                        <InventoryView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stocks/product-history"
                element={
                    <PrivateRoute permission={[Permissions.StockView]}>
                        <ProductHistory />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stocks/referrals"
                element={
                    <PrivateRoute permission={[Permissions.AuditorCreate]}>
                        <ReferralsView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/stocks/referrals/:referralId"
                element={
                    <PrivateRoute permission={[Permissions.AuditorCreate]}>
                        <ReferralDetailView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements"
                element={
                    <PrivateRoute permission={[Permissions.StockView]}>
                        <Movements />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/detail/:movementId"
                element={
                    <PrivateRoute permission={[Permissions.StockView]}>
                        <MovementStockView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/egress"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementTransfer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/egress/:movementId"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementTransfer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/ingress/:movementId"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementEditionView />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/reception/"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementReception />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/reception/:movementId"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementReception />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/adjustment/ingress"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementEditionView movementType={types.Ingress} movementSubType={subTypes.Adjustment} />
                    </PrivateRoute>
                }
            />
            <Route
                path="/movements/adjustment/egrees"
                element={
                    <PrivateRoute permission={[Permissions.StockCreate]}>
                        <MovementEditionView movementType={types.Egress} movementSubType={subTypes.Adjustment} />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/archings"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <Archings />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/archings/detail/:archingId"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <ArchingDetail />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/archings/create"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterCreate]}>
                        <CreateArching />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/closures"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <Closures />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/closures/create"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterCreate]}>
                        <CreateClosureModal />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/closures/:closureId"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <ClosureDetail />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/settlements"
                element={
                    <PrivateRoute permission={[Permissions.SettlementsCreate]}>
                        <Settlements />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/movements"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <CashRegisterMovements />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/summary"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <CashRegisterViewTotal />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/invoices"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <Invoices />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/invoices/:invoiceId"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <Invoice />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/imprestMovements"
                element={
                    <PrivateRoute permission={[Permissions.CashregisterView]}>
                        <CashRegisterImprestMovements />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/vouchers"
                element={
                    <PrivateRoute permission={[Permissions.SalesEdit]}>
                        <Vouchers />
                    </PrivateRoute>
                }
            />
            <Route
                path="/cashRegisters/vouchers/:voucherId"
                element={
                    <PrivateRoute permission={[Permissions.SalesEdit]}>
                        <Voucher />
                    </PrivateRoute>
                }
            />
            <Route
                path="/customers"
                element={
                    <PrivateRoute permission={[Permissions.CustomerView]}>
                        <Customer />
                    </PrivateRoute>
                }
            />
            <Route
                path="/customers/create"
                element={
                    <PrivateRoute permission={[Permissions.CustomerCreate]}>
                        <CustomerCreate />
                    </PrivateRoute>
                }
            />
            <Route
                path="/customers/:customerId/update"
                element={
                    <PrivateRoute permission={[Permissions.CustomerEdit]}>
                        <CustomerCreate />
                    </PrivateRoute>
                }
            />
            <Route
                path="/internalVouchers"
                element={
                    <PrivateRoute>
                        <InternalVouchers />
                    </PrivateRoute>
                }
            />
            <Route
                path="/internalVouchers/create"
                element={
                    <PrivateRoute permission={[Permissions.ComprobanteInter]}>
                        <CreateInternalVouchers />
                    </PrivateRoute>
                }
            />
            <Route
                path="/internalVouchers/detail/:ivId"
                element={
                    <PrivateRoute>
                        <DetailInternalVouchers />
                    </PrivateRoute>
                }
            />
            <Route
                path="/replacementUnits"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <ReplacementUnits />
                    </PrivateRoute>
                }
            />
            <Route
                path="/catalogs"
                element={
                    <PrivateRoute permission={[Permissions.SalesView]}>
                        <Catalogs />
                    </PrivateRoute>
                }
            />

        </Routes>
    )
}
export default Router;